export default {
  // Hero
  hero_title: "垂直建筑设备目录",
  hero_view_products: "查看产品",
  hero_request_quote: "申请报价",

  // Products Section
  products_title: "高性能设备",
  product1_name: "齿条齿轮施工升降机",
  product2_name: "带提升系统的爬升式起重机",

  // Specifications
  spec_work_height: "工作高度",
  spec_load_capacity: "载重能力",
  spec_speed: "速度",
  spec_configuration: "配置",
  spec_total_area: "总内部面积",
  spec_floor_area: "地板面积",
  spec_volume: "大约体积",
  spec_tower_height: "塔架高度",
  spec_service_height: "服务高度",
  spec_max_capacity: "最大容量",
  spec_steel_cables: "钢缆",

  // Product Details
  product1_safety_title: "安全功能",
  product1_safety_desc: "无门系统",
  product2_accessories_title: "包含配件",
  product2_accessories_desc: "最大载重2,000公斤的叉车 + 混凝土桶",

  // Video Section
  video_title: "观看设备运行",

  // Conditions
  conditions_delivery_title: '交付和付款条件',
  conditions_delivery_subtitle: '关于期限和物流的信息',
  conditions_shipping_title: '发货预测',
  conditions_shipping_desc: '订单确认后30天',
  conditions_delivery_card_title: '交付',
  conditions_delivery_desc: '发货后60天（目的港）',
  conditions_packaging_title: '包装',
  conditions_packaging_desc: '木箱',
  conditions_warranty_title: '保修',
  conditions_warranty_period: '制造商提供1年保修',
  conditions_manufacturer_title: '制造商',

  // Contact
  contact_title: "联系我们",
  contact_schedule_title: "安排会议",
  contact_schedule_desc: "通过Microsoft Teams与我们的团队交谈",
  contact_email_title: "联系我们",
  contact_email_desc: "向我们的销售团队发送电子邮件",

  // Footer
  footer_description: "垂直建筑进口设备",
  footer_products: "产品",
  footer_product1: "施工升降机",
  footer_product2: "爬升式起重机",
  footer_info: "信息",
  footer_about: "关于我们",
  footer_warranty: "保修",
  footer_delivery: "交付",
  footer_contact: "联系方式",
  footer_address: "R. Voluntários da Pátria, nº 2468 / 2490, 6楼",
  footer_building: "巴西利亚企业大厦",
  footer_hours: "周一至周五，08:30至18:00（GMT -03:00）",
  footer_rights: "© 2026 Moviis. 版权所有。",

  // Language Switcher
  language_select: "选择语言",

  share: {
    whatsappMessage: '您好！这是Moviis垂直建筑设备目录：',
    emailSubject: 'Moviis目录 — 垂直建筑设备',
    emailBody: '您好！这是Moviis垂直建筑设备目录：',
    whatsappTooltip: '通过WhatsApp分享',
    emailTooltip: '通过电子邮件分享',
  },

  // Financial Summary
  financial_title: '财务摘要',
  financial_subtitle: '价值和付款条件',
  financial_total_label: '订单总额',
  financial_total_value: '询价',
  financial_installment1_label: '第1期',
  financial_installment1_desc: '30%用于启动生产',
  financial_installment1_value: '询价',
  financial_installment2_label: '第2期',
  financial_installment2_desc: '产品付款以释放发货',
  financial_installment2_value: '询价',
  financial_installment3_label: '第3期（余额）',
  financial_installment3_desc: '到达目的地（港口或机场）',
  financial_installment3_value: '询价',
  
  // Considerations
  financial_considerations_title: '提案考虑事项',
  financial_considerations_subtitle: '重要条款和条件',
  financial_validity_label: '提案有效期：',
  financial_validity: '15天',
  financial_shipping_label: '发货期限：',
  financial_shipping: '设备必须在3个月内发货。超过此期限后，合同将被视为无效。',
  financial_observation_label: '注意：',
  financial_observation: '由于这是直接进口10台设备，任何更换或添加新项目都将导致价值重新计算。',
  financial_assembly_label: '组装和技术维护：',
  financial_assembly: '不包括（买方责任）。',
  
  // Action Buttons
  financial_btn_print: '打印',
  financial_btn_pdf: '下载PDF',
  financial_btn_whatsapp: '通过WhatsApp发送',
  financial_btn_email: '通过电子邮件发送',
};